export default {
  maxBulkEditItems: 50,
  //These owners are typically a process and have special restrictions with edits.
  processOwners: ['PCE', 'PAX'],
}
